import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { Configuration } from '../models/configuration';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  currentUser: User | undefined;

  constructor(private http: HttpClient) {}

  setUser(user: User) {
    this.currentUser = user;
  }

  getConf() {
    return this.http.get<Configuration>('configuration.json');
  }
}
